import styled from "styled-components";

export const AmusnetWidgetAmountDefaultBox = styled.div<{widgetWidth: number}>`
    border: 2px solid transparent;
    border-radius: 45px;
    background: linear-gradient(90deg, #1D0C33 0%, #4C356B 50%, #1D0C33 100%) padding-box,
        linear-gradient(70deg, rgba(151, 71, 255, 0.5) 8%, rgba(252, 228, 3, 0.5) 47%, rgba(127, 248, 0, 0.5) 82%) border-box;
    font-size: ${({widgetWidth}) => widgetWidth * 18 / 130}px;
    color: ${({theme}) => theme.colors.moneyColor};
    ${({theme}) => theme.font.presets.bold}
    padding-block: 0.3rem;
    text-align: center;
    width: 100%;
    text-shadow: 0px 1px 3px black;
    
    @media ${({theme}) => theme.mediaQuery.xlAndAbove} {
        font-size: ${({widgetWidth}) => widgetWidth * 33 / 240}px;
        padding-block: 1rem;
    }

    @media ${({theme}) => theme.mediaQuery.xxl} {
        ${({theme}) => theme.font.presets.black}
    }

    span:last-of-type {
        font-size: ${({widgetWidth}) => widgetWidth * 14 / 130}px;

        @media ${({theme}) => theme.mediaQuery.xlAndAbove} {
            font-size: ${({widgetWidth}) => widgetWidth * 25 / 240}px;
        }
    }
`;
